import React from 'react';
import { Box, styled } from '@mui/material';
import ClosedMenuLogo from '../../assets/logo/closed-menu.png';

interface CircularIndeterminateProps {
  styles?: React.CSSProperties;
  centered?: boolean;
}

const SpinningContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: '45%',
  top: '25%',
  width: '2em',
  height: '2em',
  backgroundSize: 'contain',
  display: 'block',
  margin: 'auto',
  '& .loading-logo': {
    width: '100px',
    height: '100px',
    animation: 'scale 2s linear infinite',
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  '@keyframes scale': {
    '0%, 100%': {
      transform: 'rotate(0deg) scale(1)',
    },
    '50%': {
      transform: 'rotate(180deg) scale(1.1)',
    },
  },
}));

const CenteredBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '1rem',
}));

const CircularIndeterminate: React.FC<CircularIndeterminateProps> = ({ styles = {}, centered = false, ...props }) => {
  return (
    <SpinningContainer sx={{ ...styles }}>
      <CenteredBox sx={{ display: centered ? 'flex' : 'none' }}>
        <div className="root">
          <div className="loading-container">
            <img src={ClosedMenuLogo} alt="Loading" className="loading-logo" />
          </div>
        </div>
      </CenteredBox>
    </SpinningContainer>
  );
};

export default CircularIndeterminate;
